/**
 * @generated SignedSource<<51800f52053e5dfe2cae16dbe2a4852b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UploadEmailTemplateImageInput = {
  data: string;
  emailTemplateIdentifier: string;
  filename: string;
  mediaType: string;
};
export type ImageBlockEditorUploadMutation$variables = {
  input: UploadEmailTemplateImageInput;
};
export type ImageBlockEditorUploadMutation$data = {
  readonly uploadEmailTemplateImage: {
    readonly emailTemplateImageIdentifier: string;
    readonly fileSize: number;
    readonly height: number;
    readonly id: string;
    readonly mediaType: string;
    readonly originalFilename: string;
    readonly url: string;
    readonly width: number;
  };
};
export type ImageBlockEditorUploadMutation = {
  response: ImageBlockEditorUploadMutation$data;
  variables: ImageBlockEditorUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailTemplateImage",
    "kind": "LinkedField",
    "name": "uploadEmailTemplateImage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailTemplateImageIdentifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "originalFilename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mediaType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileSize",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImageBlockEditorUploadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImageBlockEditorUploadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2be3fd4e6a983c9f25df0eefa5876e2b",
    "id": null,
    "metadata": {},
    "name": "ImageBlockEditorUploadMutation",
    "operationKind": "mutation",
    "text": "mutation ImageBlockEditorUploadMutation(\n  $input: UploadEmailTemplateImageInput!\n) {\n  uploadEmailTemplateImage(input: $input) {\n    id\n    emailTemplateImageIdentifier\n    url\n    originalFilename\n    width\n    height\n    mediaType\n    fileSize\n  }\n}\n"
  }
};
})();

(node as any).hash = "3cb04c4f1351230ba383f9ea6fdb3706";

export default node;
